import React from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { RangeSizesType } from 'types/Sizes';
import { cssTheme } from '../../../../themes';
interface PageWidthContainerPropsType {
  /** The page content */
  children: React.ReactNode;
  /** A class name that can be given to the container */
  className?: string;
  /** The max width the page will be refined to. If not supplied it is taken from the theme file */
  maxPageWidth?: number;
  /** Whether to span the container full width - this will override maxPageWidth */
  isFullWidth?: boolean;
  /** The page padding at the desktop-sm breakpoint. Only spacing sizes from the theme are accepted */
  paddingDesktopSmSize?: RangeSizesType;
  /** The page padding at the desktop-xs breakpoint. Only spacing sizes from the theme are accepted */
  paddingDesktopXsSize?: RangeSizesType;
  /** The page padding at the desktop-md breakpoint. Only spacing sizes from the theme are accepted */
  paddingDesktopMdSize?: RangeSizesType;
  /** The page padding at the desktop-lg breakpoint. Only spacing sizes from the theme are accepted */
  paddingDesktopLgSize?: RangeSizesType;
  /** The page padding at the mobile-sm breakpoint. Only spacing sizes from the theme are accepted */
  paddingMobileSmSize?: RangeSizesType;
  /** The page padding at the mobile-lg breakpoint. Only spacing sizes from the theme are accepted */
  paddingMobileLgSize?: RangeSizesType;
}
type PageWidthContainerElementPropsType = Omit<PageWidthContainerPropsType, 'children' | 'className'>;
const getPadding = (size?: RangeSizesType) => cssTheme.layout.spacing[size || 's000'];
const _exp = /*#__PURE__*/() => ({
  isFullWidth,
  maxPageWidth
}) => isFullWidth ? '100%' : maxPageWidth ? `${maxPageWidth}px` : cssTheme.layout.maxPageWidth;
const _exp2 = /*#__PURE__*/() => ({
  paddingMobileSmSize
}) => getPadding(paddingMobileSmSize);
const _exp4 = /*#__PURE__*/() => ({
  paddingMobileLgSize
}) => getPadding(paddingMobileLgSize);
const _exp6 = /*#__PURE__*/() => ({
  paddingDesktopXsSize
}) => getPadding(paddingDesktopXsSize);
const _exp8 = /*#__PURE__*/() => ({
  paddingDesktopSmSize
}) => getPadding(paddingDesktopSmSize);
const _exp10 = /*#__PURE__*/() => ({
  paddingDesktopMdSize
}) => getPadding(paddingDesktopMdSize);
const _exp12 = /*#__PURE__*/() => ({
  paddingDesktopLgSize
}) => getPadding(paddingDesktopLgSize);
const PageWidthContainerElement = /*#__PURE__*/styled('div')({
  name: "PageWidthContainerElement",
  class: "p55rhqj",
  propsAsIs: false,
  vars: {
    "p55rhqj-0": [_exp()],
    "p55rhqj-1": [_exp2()],
    "p55rhqj-2": [_exp4()],
    "p55rhqj-3": [_exp6()],
    "p55rhqj-4": [_exp8()],
    "p55rhqj-5": [_exp10()],
    "p55rhqj-6": [_exp12()]
  }
});
export const PageWidthContainer = ({
  children,
  className,
  isFullWidth,
  maxPageWidth,
  paddingDesktopLgSize,
  paddingDesktopMdSize,
  paddingDesktopSmSize,
  paddingDesktopXsSize,
  paddingMobileSmSize,
  paddingMobileLgSize
}: PageWidthContainerPropsType) => <PageWidthContainerElement className={cx(className, paddingDesktopLgSize && '--has-paddingDesktopLgSize', paddingDesktopMdSize && '--has-paddingDesktopMdSize', paddingDesktopSmSize && '--has-paddingDesktopSmSize', paddingDesktopXsSize && '--has-paddingDesktopXsSize', paddingMobileSmSize && '--has-paddingMobileSmSize', paddingMobileLgSize && '--has-paddingMobileLgSize')} maxPageWidth={maxPageWidth} isFullWidth={isFullWidth} paddingDesktopLgSize={paddingDesktopLgSize} paddingDesktopMdSize={paddingDesktopMdSize} paddingDesktopSmSize={paddingDesktopSmSize} paddingDesktopXsSize={paddingDesktopXsSize} paddingMobileSmSize={paddingMobileSmSize} paddingMobileLgSize={paddingMobileLgSize}>
    {children}
  </PageWidthContainerElement>;

require("./PageWidthContainer.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PageWidthContainer.tsx");